//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { eActionState } from './enums';
import { eContactType } from './enums';
import { eCountry } from './enums';
import { eImageSize } from './enums';
import { eDatabaseContactType } from './enums';
import { eCurrency } from './enums';
import { eModules } from './enums';
import { eUserRole } from './enums';
import { eBusinessUnit } from './enums';
import { eUserType } from './enums';
import { eOffice } from './enums';
import { eGender } from './enums';
import { eDepartment } from './enums';
import { eSystemModule } from './enums';
import { eUserPermissionLevel } from './enums';
import { eDefaultPane } from './enums';
import { eItineraryView } from './enums';
import { eTvPckgDepartment } from './enums';
import { eTvPckgProjectStatus } from './enums';
import { eTvPckgGenre } from './enums';
import { eTvPckgLength } from './enums';
import { eTvPckgOutletType } from './enums';
import { eTvPckgPackageStatus } from './enums';
import { eTvPckgNavTransactionState } from './enums';
import { eTvPckgNavServiceType } from './enums';
import { eTVPType } from './enums';
import { eTvPckgSplitStatus } from './enums';
import { eTvPckgShareType } from './enums';
import { eTvPckgBeStatus } from './enums';
import { eTvPckgBeOwner } from './enums';
import { eTvPckgElementWorkType } from './enums';
import { eTvPckgAgency } from './enums';
import { eTvPckgElementStatus } from './enums';
import { eTvPckgPosition } from './enums';
import { eTvPckgNoteType } from './enums';
import { eTvPckgNoteSender } from './enums';
import { eTvPckgNavReloadState } from './enums';
import { eTvPckgBookingStatus } from './enums';
import { eTvPckgTmsBookingStatus } from './enums';
import { eTvPckgBookingType } from './enums';
import { eTvPckgPaymentStatus } from './enums';
import { eTvPckgTvBooking } from './enums';
import { eTv10PercentPosition } from './enums';
import { eTv10PercentAttachmentType } from './enums';
import { eTv10PercentBookingCategory } from './enums';
import { eTv10PercentBookingStatus } from './enums';
import { eTv10PercentBookingType } from './enums';
import { eTv10PercentLength } from './enums';
import { eTv10PercentFormat } from './enums';
import { eTv10PercentLevel } from './enums';
import { eTv10PercentBookingNoteType } from './enums';
import { eTv10PercentPaymentType } from './enums';
import { eItineraryClientListTypes } from './enums';
import { eContactSection } from './enums';
import { eSearchContactType } from './enums';
import { eSearchContactSubType } from './enums';
import { eSearchUserSubType } from './enums';
import { eSearchAgentSubType } from './enums';
import { eClientStatus } from './enums';
import { eContactWorkArea } from './enums';
import { eContactWorkType } from './enums';
import { eBuyerMarket } from './enums';
import { eEthnicity } from './enums';
import { eNationality } from './enums';
import { eContactAgeRange } from './enums';
import { eExternalCalendarTypes } from './enums';
import { eReportType } from './enums';
import { eColumnType } from './enums';
import { eGridArea } from './enums';
import { eGridType } from './enums';
import { eSortDir } from './enums';
import { eFilterFieldType } from './enums';
import { eDealStatus } from './enums';
import { eDealType } from './enums';
import { eDealCrossCollateralizedLevel } from './enums';
import { eClientType } from './enums';
import { eRegion } from './enums';
import { eContactTitle } from './enums';
import { eClientPhoneType } from './enums';
import { eClientEmailType } from './enums';
import { eBuyerEmailType } from './enums';
import { eBuyerPhoneType } from './enums';
import { eCitizenship } from './enums';
import { eContactCategory } from './enums';
import { eContactStatusFilter } from './enums';
import { eContactStatus } from './enums';
import { eContactEmailType } from './enums';
import { eContactPhoneType } from './enums';
import { eContactAttachmentType } from './enums';
import { eClientGenreLiterary } from './enums';
import { eClientGenreFilmAndTv } from './enums';
import { eClientGenreMusic } from './enums';
import { eClientNotifyLevel } from './enums';
import { eClientDepartment } from './enums';
import { eClientPaymentMethod } from './enums';
import { eClientParticipantType } from './enums';
import { eClientAttachmentType } from './enums';
import { eBuyerCompanyType } from './enums';
import { eDealBuyerAssociate } from './enums';
import { eBuyerCategory } from './enums';
import { eBuyerNotificationMethod } from './enums';
import { eBuyerAttachmentType } from './enums';
import { eContactCardType } from './enums';
import { eContactVenueLocation } from './enums';

export class BaseDto
{
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class AssociateDto
{
	public ContactId: string;
	public RecordId: string;
	public Comment: string;
	public Name: string;
	public ContactTypeId: eContactType;
	public ContactType: string;
	public Company: string;
	public Contact: ContactDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class AddressDto
{
	public CountryId?: eCountry;
	public ContactCardType?: eContactType;
	public Title: string;
	public Country: string;
	public CountryShort: string;
	public AddressStringFromGoogle: string;
	public AddressLine1: string;
	public AddressLine2: string;
	public AddressLine3: string;
	public City: string;
	public State: string;
	public PostalCode: string;
	public Comment: string;
	public AddressString: string;
	public GoogleMapsUrl: string;
	public Latitude?: number;
	public Longitude?: number;
	public IsPrefered?: boolean;
	public IsAccounting?: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class AgentDto
{
	public Id: string;
	public EmployeeId: string;
	public FullName: string;
	public IsSigningAgent: boolean;
	public IsPointAgent: boolean;
}
export class AmountDto
{
	public Amount: number;
	public Currency: CurrencyDto;
}
export class AngularPrivateApiSettingsDto
{
	public GoogleApiKey: string;
	public AgGridKey: string;
}
export class AngularPublicApiSettingsDto
{
	public UseMockUser: boolean;
	public AzureTenant: string;
	public AzureClientId: string;
	public AzureAudience: string;
	public AllowCustomLogin: boolean;
	public ConnectUrl: string;
}
export class AttachmentDto
{
	public FileName: string;
	public Description: string;
	public FileId: string;
	public IsDeleted: boolean;
	public User: string;
	public Date: Date;
	public SizeInBytes: number;
	public ImageSize: eImageSize;
	public Path: string;
	public EmlAttachmentNum: number;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BaseConnectContact
{
	public ConnectId?: number;
	public ContactConnectUrlAddress: string;
}
export class BaseListItemDto
{
	public Key: number;
	public Value: string;
	public IsSelected: boolean;
}
export class ContactLoanoutDto
{
	public ContactLoanoutId: string;
	public ContactId: string;
	public RecordId: string;
	public LoanoutName: string;
	public TaxNumber: string;
	public Suffix: string;
	public Note: string;
	public CreatedBy: string;
	public IsUk: boolean;
	public IsAus: boolean;
	public IsGSTReg: boolean;
	public IsActive: boolean;
	public IsForeign: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactSelectorDto
{
	public Id: string;
	public FullName: string;
	public EntityType: eDatabaseContactType;
}
export class CountryDto
{
	public Id: number;
	public Name: string;
	public IsoCode: string;
}
export class CurrencyAmountDto
{
	public Amount?: number;
	public Currency: CurrencyDto;
	public AlternativeAmount?: number;
	public AlternativeCurrency: CurrencyDto;
}
export class CurrencyDto
{
	public Currency: eCurrency;
	public ShortName: string;
	public Name: string;
	public Symbol: string;
	public ExchangeRate?: number;
}
export class IDictionaryDto
{
}
export class DictionaryDto
{
	public Id: string;
	public Value: string;
}
export class EmailAddressDto
{
	public Email: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class EmailDto
{
	public Id: string;
	public Type: string;
	public Address: string;
}
export class EmailPreviewDto
{
	public HTMLBody: string;
	public To: string;
	public Cc: string;
	public Subject: string;
	public Attachments: string[];
}
export class FullNameDto
{
	public FirstName: string;
	public MiddleName: string;
	public LastName: string;
}
export class GeoLocationDto
{
	public Latitude: number;
	public Longitude: number;
}
export class HyperlinkDto
{
	public Value: string;
	public Slug: string;
	public Tooltip: string;
	public ModuleId: eModules;
	public ExternalUrlAddress: string;
}
export class ImageColumnDto
{
	public ImageUrl: string;
	public Tooltip: string;
	public TargetUrl: string;
}
export class PhoneNumberDto
{
	public Number: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class SearchContactResultDto
{
	public Id: string;
	public FullName: string;
	public Avatar: string;
}
export class SelectListDto
{
	public DataTextfield: string;
	public DataValueField: string;
	public Items: any[];
	public SelectedValue: any;
}
export class SelectListItemDto
{
	public Text: string;
	public Value: string;
	public Selected: boolean;
}
export class ServerPagingResultDto<TData>
{
	public Data: TData[];
	public Total: number;
	public HasNextPage: boolean;
}
export class StateDto
{
	public Id: number;
	public Code: string;
	public Name: string;
}
export class UploadDto
{
	public AttachmentId: string;
	public FileId: string;
	public Path: string;
	public FileName: string;
}
export class UserDto
{
	public Id: string;
	public UserName: string;
	public FullName: string;
	public Email: string;
	public Phone: string;
	public UserRoleId: eUserRole;
	public TimeZoneId: number;
	public IsLocked: boolean;
	public IsActive: boolean;
}
export class UserTimeZoneDto
{
	public Id: number;
	public Name: string;
	public JsName: string;
	public UTCOffSet: string;
	public Description: string;
}
export class ErrorJs
{
	public Url: string;
	public Message: string;
	public Stack: string;
}
export class ErrorDto
{
	public Subject: string;
	public Message: string;
	public Stack: string;
}
export class TestDataDto
{
	public Name: string;
	public Position: string;
	public Salary: string;
	public StartDate: string;
	public Office: string;
	public Extn: string;
}
export class EnumTypeDto
{
	public Name: string;
	public EnumValues: EnumValueDto[];
}
export class EnumValueDto
{
	public Id: number;
	public Value: string;
	public Description: string;
}
export class FilterConverter
{
	public CanWrite: boolean;
	public CanRead: boolean;
}
export abstract class AUserBase
{
	public Id: string;
	public UserName: string;
	public FirstName: string;
	public LastName: string;
}
export class SetUserPasswordDto
{
	public Id: string;
	public Password: string;
}
export class UserDetailDto
{
	public AzureObjectId: string;
	public FullName: string;
	public EmployeeNumber?: number;
	public BusinessUnitId?: eBusinessUnit;
	public EmployeeTypeId: eUserType;
	public Office?: eOffice;
	public Position: string;
	public Initials: string;
	public GenderId?: eGender;
	public StartTime?: Date | null;
	public Email: string;
	public Settings: UserSettingsDto;
	public Departments: eDepartment[];
	public SecurityRoles: eUserRole[];
	public UserRoleSystemModules: UserRoleSystemModuleDto[];
	public IsActive: boolean;
	public IsDeleted: boolean;
	public Employee: ContactCardDto;
	public ConnectId?: number;
	public Id: string;
	public UserName: string;
	public FirstName: string;
	public LastName: string;
}
export class UserGridDto
{
	public Id: string;
	public FullName: HyperlinkDto;
	public Username: string;
	public Office: string;
	public UserType: string;
	public BusinessUnit: string;
	public HasSecurityRole: boolean;
}
export class UserLoginHistoryDto
{
	public Id: string;
	public AdminUserId: string;
	public Login: Date;
	public Logout?: Date | null;
	public IpAddress: string;
}
export class UserRoleSystemModuleDto
{
	public Id: number;
	public UserRoleId: eUserRole;
	public SystemModuleId: eSystemModule;
	public UserPermissionLevelFlag: eUserPermissionLevel;
}
export class UserSettingsDto
{
	public Id: string;
	public AvatarId: string;
	public UserName: string;
	public TimeZoneJs: string;
	public FullName: string;
	public PrimaryPhone: string;
	public SecondaryPhone: string;
	public DefaultPane: eDefaultPane;
	public TimeZone: UserTimeZoneDto;
	public Grid: UserGridSettings;
	public Itinerary: UserItinerarySettings;
}
export class UserGridSettings
{
	public DefaultMainGridPageSize: number;
	public DefaultSubGridPageSize: number;
	public MainGridPageSizes: UserGridSettingPageSize[];
	public SubGridPageSizes: UserGridSettingPageSize[];
}
export class UserItinerarySettings
{
	public IsItineraryLeftBarOpen: boolean;
	public IsItineraryRightBarOpen: boolean;
	public IsItineraryLeftBarPinned: boolean;
	public IsItineraryRightBarPinned: boolean;
	public DefaultItinerary?: string;
	public DefaultItineraryView: eItineraryView;
}
export class UserGridSettingPageSize
{
	public Id: string;
	public PageSize: number;
}
export class SearchPreCrmDto
{
	public Description: string;
	public Id: string;
	public ProjectTitle: string;
	public TvPckgPreCrmDataId: string;
	public TvPckgPackageId: string;
	public Url: string;
}
export class TVPPreCrm_assocDto
{
	public Id: string;
	public ProjectTitle: string;
	public TvPckgPreCrmDataId: string;
	public TvPckgPackageId: string;
	public Url: string;
}
export class TVPPreCrmDto
{
	public ProjectTitle: string;
	public ProjectStatus: string;
	public TvPackages: HyperlinkDto[];
	public TvPackagesAssocs: TVPPreCrm_assocDto[];
	public Package: string;
	public PackageNotes: string;
	public Agents: string;
	public PackageBookingSlipNumber: string;
	public PackageElements: string;
	public Department: string;
	public ConfirmationStatus: string;
	public ConfirmationStatusNotes: string;
	public SplitStatus: string;
	public SplitStatusNotes: string;
	public ControllingAgency: string;
	public OtherAgency: string;
	public OtherAgencyElements: string;
	public OtherEndClients: string;
	public StudioProductionCompanyBuyer: ContactCardDto;
	public StudioProductionCompanyNotes: string;
	public StudioProductionContact: string;
	public NetworkCompanyBuyer: ContactCardDto;
	public NetworkCompanyNotes: string;
	public NetworkContact: string;
	public FmpIdentifier?: number;
	public FmpModifiedOn?: Date | null;
	public FmpCreatedOn?: Date | null;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPPreCrmGridDataDto
{
	public Id: string;
	public ProjectTitle: HyperlinkDto;
	public ProjectStatus: string;
	public TvPackages: string[];
	public Package: string;
	public PackageNotes: string;
	public Agents: string;
	public PackageBookingSlipNumber: string;
	public PackageElements: string;
	public Department: string;
	public ConfirmationStatus: string;
	public ConfirmationStatusNotes: string;
	public SplitStatus: string;
	public SplitStatusNotes: string;
	public ControllingAgency: string;
	public OtherAgency: string;
	public OtherAgencyElements: string;
	public OtherEndClients: string;
	public StudioProductionCompanyBuyer: HyperlinkDto;
	public StudioProductionCompanyNotes: string;
	public StudioProductionContact: string;
	public NetworkCompanyBuyer: HyperlinkDto;
	public NetworkCompanyNotes: string;
	public NetworkContact: string;
	public FmpIdentifier?: number;
	public CreatedOn?: Date | null;
	public FmpModifiedOn?: Date | null;
	public FmpCreatedOn?: Date | null;
}
export class TvPckgPreCrmsDto
{
	public TvPckgPreCrmDataId: string;
	public TvPreCrmAssocs: TVPPreCrm_assocDto[];
}
export class TVBookingGridDataDto
{
	public Id: string;
	public ProjectTitle: HyperlinkDto;
	public SeasonNumber: number;
	public StudioProdCompany: HyperlinkDto;
	public Network: HyperlinkDto;
	public OutletType: string;
	public Genre: string;
	public EpisodeInSeason: number;
	public ScheduledUfRemaining?: number;
	public TotalUfReceived?: number;
	public EstPremiereDate?: Date | null;
	public SeasonPremiereDate?: Date | null;
	public TvSeason: string;
	public SeasonStatus: string;
	public Currency: CurrencyDto;
	public Department: string;
	public PackagingAgents: string[];
	public BEOwner: string;
	public Payer: string[];
	public AddBEOwner: string;
	public BEPaymentTotal?: number;
	public NAVBooking: string;
	public CreatedOn?: Date | null;
}
export class TVPackageAgent_assocDto
{
	public Id: string;
	public TvPckgId: string;
	public UserId: string;
	public FullName: string;
	public IsPointAgent: boolean;
	public Order?: number;
	public ContactCard: ContactCardDto;
	public ConnectId?: number;
	public ContactConnectUrlAddress: string;
}
export class TVPackageContact_assocDto
{
	public Id: string;
	public TvPckgId: string;
	public ContactId: string;
	public TvPckgContactTypeId: number;
	public FullName: string;
	public ConnectId?: number;
	public ContactConnectUrlAddress: string;
}
export class TVPackageFormDto
{
	public ProjectTitle: string;
	public AlternativeTitles: string;
	public Department: eTvPckgDepartment;
	public ProjectStatus?: eTvPckgProjectStatus;
	public Genre?: eTvPckgGenre;
	public Length?: eTvPckgLength;
	public StudioProdCompany: ContactCardDto;
	public NetworkCompanyBuyer: ContactCardDto;
	public OutletType?: eTvPckgOutletType;
	public PackageClient: ContactCardDto;
	public PilotOrderedDate?: Date | null;
	public SerieOrderedDate?: Date | null;
	public SeriesStartDate?: Date | null;
	public SeriesEndDate?: Date | null;
	public PackageStatus?: eTvPckgPackageStatus;
	public PackageLetterRequested?: Date | null;
	public PackageLetterIssued?: Date | null;
	public PackageClearedByBAAgent: ContactCardDto;
	public SplitConfirmedByBAAgent: ContactCardDto;
	public Agents: TVPackageAgent_assocDto[];
	public BuyerContacts: TVPackageContact_assocDto[];
	public AccountingContacts: TVPackageContact_assocDto[];
	public PreCrmDatas: TVPPreCrm_assocDto[];
	public IsDeleted: boolean;
	public IsPremiumDigital?: boolean;
	public IsWMEPackage?: boolean;
	public NavId: string;
	public NavTransactionDate?: Date | null;
	public NavTransactionStateId?: eTvPckgNavTransactionState;
	public TvPckgNavServiceTypeId?: eTvPckgNavServiceType;
	public NavTransactionError: string;
	public NavReloadError: string;
	public AgentsLog: string;
	public BuyerContactsLog: string;
	public AccountingContactsLog: string;
	public PreCrmDatasLog: string;
	public IsCreatingBooking: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPackageGridDataDto
{
	public Id: string;
	public ProjectTitle: HyperlinkDto;
	public AlternativeTitles: string;
	public PackageStatus: string;
	public OutletType: string;
	public Genre: string;
	public SplitSummary: string;
	public SeriesStartDate?: Date | null;
	public SeriesEndDate?: Date | null;
	public PackageLetterRequested?: Date | null;
	public PackageLetterIssuedDate?: Date | null;
	public BuyerStudioProdCompany: HyperlinkDto;
	public BuyerNetworkCompany: HyperlinkDto;
	public Department: string;
	public ProjectStatus: string;
	public BeStatus: string;
	public WMEPosition: string;
	public OtherAgency: string[];
	public SplitStatus: string;
	public PackagingAgents: string[];
	public CreatedOn: Date;
	public NavId: string;
}
export class TVPackageNoteDeleteDto
{
	public Id: string;
	public Type: eTVPType;
}
export class TVPackageNoteDetailDto
{
	public Id: string;
	public Type: eTVPType;
	public NoteDetail: string;
}
export class TVPackageSplitFormDto
{
	public PackageId: string;
	public SplitStatusId?: eTvPckgSplitStatus;
	public SplitAgency1ShareTypeId?: eTvPckgShareType;
	public SplitAgency1ShareTypeOther: string;
	public SplitAgency2ShareTypeId?: eTvPckgShareType;
	public SplitAgency2ShareTypeOther: string;
	public SplitAgency1: ContactCardDto;
	public SplitAgency2: ContactCardDto;
	public SplitCalculation: string;
	public SplitAgencyMiscNotes: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPackageTermFormDto
{
	public SplitStatus?: eTvPckgSplitStatus;
	public WmeUpfrontCommission: string;
	public WmeDeferredCommission: string;
	public WmeBeCommission: string;
	public WmeDeferral: string;
	public CommissionBump: string;
	public BeStatus?: eTvPckgBeStatus;
	public BeOwner?: eTvPckgBeOwner;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TvPckgElementWorkType_assocDto
{
	public Id: string;
	public TvPckgElementId: string;
	public TvPckgElementWorkTypeId: eTvPckgElementWorkType;
}
export class TVPElementDto
{
	public IsClient: boolean;
	public NonClientName: string;
	public TvPckgAgencyId?: eTvPckgAgency;
	public OtherAgency: string;
	public ClientTalent: ContactCardDto;
	public ElementStatus?: eTvPckgElementStatus;
	public ElementWorkTypes: eTvPckgElementWorkType[];
	public PackageId: string;
	public Note: string;
	public ElementWorkTypesLog: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPElementGridDto
{
	public Id: string;
	public IsClient: boolean;
	public NonClientName: string;
	public ClientTalentCard: ContactCardDto;
	public ClientTalent: HyperlinkDto;
	public OtherAgency: string;
	public ElementWorkTypes: string[];
	public ElementStatus: string;
	public Note: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPPackageBookingSummaryDto
{
	public SsnsCompleted?: number;
	public EpsCompleted?: number;
	public SsnsOrdered?: number;
	public EpsOrdered?: number;
	public SsnsProjected?: number;
	public EpsProjected?: number;
	public UltimateOfSsns?: number;
	public UltimateOfEps?: number;
	public TotalUfReceived?: number;
	public BePaymentsTotal?: number;
	public UfScheduledPayments?: number;
	public ScheduledUfRemaining?: number;
	public TmsTotalUfReceived?: number;
	public TmsUfScheduledPayment?: number;
	public TmsBePaymentsTotal?: number;
}
export class TVPPackageDto
{
	public TVPackageForm: TVPackageFormDto;
	public TVPackageTermForm: TVPackageTermFormDto;
	public TVPSeasonInfos: TVPSeasonInfoDto[];
	public TVPBeBookingInfos: TVPBeBookingInfoDto[];
	public TVPBooking: TVPBookingDto;
	public TVPBackendBooking: TVPBackendBookingDto;
	public TVPBookingSummary: TVPPackageBookingSummaryDto;
	public BackendBookingId?: string;
	public HasBookingPostedToNav: boolean;
	public HasUpfrontBooking: boolean;
	public HasBackendBooking: boolean;
	public TVPackageTermAgencies: TVPPackageTermAgencyDto[];
	public TVPackageElements: TVPElementDto[];
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPPackageTermAgencyDto
{
	public PackageTermId: string;
	public Agency: string;
	public TvPckgAgencyId: eTvPckgAgency;
	public ShareType?: eTvPckgShareType;
	public PackagePosition?: eTvPckgPosition;
	public Note: string;
	public PackageId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPPackageTermAgencyGridDto
{
	public Agency: string;
	public TvPckgAgencyId: number;
	public ShareType: string;
	public PackagePosition: string;
	public TvPckgPackagePositionId?: number;
	public Note: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class PostToNavDto
{
	public TvpType: eTVPType;
	public Id: string;
	public IsReloadToNav: boolean;
}
export class TVPBookingPayer_assocDto
{
	public Id: string;
	public TvPckgBookingId: string;
	public BuyerId: string;
}
export class TVPackageNoteDto
{
	public TvpType: eTVPType;
	public TvPckgId: string;
	public TvPckgNoteTypeId: eTvPckgNoteType;
	public Note: string;
	public IsDeleted: boolean;
	public User: string;
	public Date: Date;
	public Attachment: AttachmentDto;
	public TvPckgNoteSenderId?: eTvPckgNoteSender;
	public SenderBuyerId?: string;
	public NoteDetail: string;
	public NoteDate?: Date | null;
	public SenderName: string;
	public IsActivePackageLetter?: boolean;
	public SenderId?: string;
	public Buyer: ContactCardDto;
	public Client: ContactCardDto;
	public Contact: ContactCardDto;
	public Employee: ContactCardDto;
	public Venue: ContactCardDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPBackendBookingDto
{
	public TvPckgPackageId: string;
	public OwnerContactId: string;
	public Name: string;
	public IsManuallyManaged: boolean;
	public IsDeleted: boolean;
	public IsActive: boolean;
	public NavId: string;
	public NavTransactionDate?: Date | null;
	public NavTransactionStateId?: eTvPckgNavTransactionState;
	public NavServiceTypeId?: eTvPckgNavServiceType;
	public TvPckgNavReloadStateId?: eTvPckgNavReloadState;
	public TvPckgBookingStatusId?: eTvPckgBookingStatus;
	public CurrencyId: eCurrency;
	public NavServiceType: string;
	public NavReloadDate?: Date | null;
	public NavTransactionState: string;
	public NavTransactionError: string;
	public NavReloadError: string;
	public BookingDate?: Date | null;
	public AdditionalBeOwnerId?: eTvPckgBeOwner;
	public ClearOtherBookingNavId?: boolean;
	public PayerBuyers: ContactCardDto[];
	public AccountingContact: ContactCardDto;
	public BookingAgent: ContactCardDto;
	public TmsId: string;
	public BookingStatus: eTvPckgTmsBookingStatus;
	public BookingNumber: string;
	public HasTMSPayments: boolean;
	public PayerBuyersLog: string;
	public IsTMSEligible: boolean;
	public IsTMS: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPBeBookingInfoDto
{
	public Id: string;
	public SeasonStatusName: string;
	public TvSeasonName: string;
	public AltSeason: string;
	public CurrencyId: eCurrency;
	public Season: number;
	public EpisodesInSeason?: number;
	public SeasonPremiereDate?: Date | null;
	public UfPaymentsReceived?: number;
	public EstimateUfPerSeason?: number;
	public EstimateUfPerEp?: number;
	public ScheduledUfRemaining?: number;
	public NavId: string;
	public IsActive: boolean;
	public BookingNumber: string;
	public IsManuallyManaged: boolean;
}
export class TVPBookingDto
{
	public Id: string;
	public SeasonForm: TVPSeasonFormDto;
	public IsManuallyManaged?: boolean;
	public ActionState: eActionState;
	public ClearOtherBookingNavId?: boolean;
	public IsTMSEligible: boolean;
	public IsTMS: boolean;
}
export class TVPBookingNavDto
{
	public Id?: string;
	public NavId: string;
	public Name: string;
	public ScheduledUfRemaining?: number;
	public UfPaymentsReceived?: number;
	public BePaymentsTotal?: number;
	public TvPckgBookingTypeId: eTvPckgBookingType;
}
export class TVPckgPaymentDto
{
	public TvPckgPackageId: string;
	public TvPckgBookingId?: string;
	public ServiceDate?: Date | null;
	public Description: string;
	public DueDate?: Date | null;
	public ActivityType: string;
	public ServiceType: string;
	public CurrencyId: eCurrency;
	public ExpectedAmount: number;
	public ReceivedAmount: number;
	public RemainingAmount: number;
	public InvoiceDate?: Date | null;
	public TvPckgPaymentStatusId?: eTvPckgPaymentStatus;
	public PaymentStatus: string;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public BookingActivityTmsId: string;
	public BookingActivityNavId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPMigrateBookingToTmsRequestDto
{
	public BookingId: string;
}
export class TVPPaymentFormDto
{
	public Id: string;
	public EpisodeNumber: string;
	public TvPckgBookingId?: string;
}
export class TVPSeasonFormDto
{
	public TvPckgPackageId: string;
	public TvSeason?: eTvPckgTvBooking;
	public SeasonStatus?: eTvPckgBookingStatus;
	public CurrencyId: eCurrency;
	public SeasonName: string;
	public ProductionStartDate?: Date | null;
	public SeasonPremiereDate?: Date | null;
	public IsPremiereDateConfirmed: boolean;
	public SeasonNumber: number;
	public AlternativeSeason: string;
	public EpisodesInSeason?: number;
	public EstimateUfPerEpisode?: number;
	public EstimateUfPerSeason?: number;
	public CommisionFormula: string;
	public IsUprontConfirmed?: boolean;
	public UfPaymentsReceived?: number;
	public ScheduledUfRemaining?: number;
	public NavId: string;
	public NavTransactionDate?: Date | null;
	public NavTransactionStateId?: eTvPckgNavTransactionState;
	public TvPckgNavReloadStateId?: eTvPckgNavReloadState;
	public NavTransactionState: string;
	public NavReloadDate?: Date | null;
	public BookingDate?: Date | null;
	public NavTransactionError: string;
	public NavReloadError: string;
	public IsManuallyManaged: boolean;
	public IsDeleted: boolean;
	public NetworkCompany: ContactCardDto;
	public StudioProdCompany: ContactCardDto;
	public AccountingContact: ContactCardDto;
	public BookingAgent: ContactCardDto;
	public IsActive: boolean;
	public TmsId: string;
	public TmsUfPaymentsReceived?: number;
	public TmsUfScheduledPayments?: number;
	public TmsScheduledUfRemaining?: number;
	public BookingStatus: eTvPckgTmsBookingStatus;
	public BookingNumber: string;
	public HasTMSPayments?: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class TVPSeasonInfoDto
{
	public Id: string;
	public SeasonStatusName: string;
	public TvSeasonName: string;
	public AltSeason: string;
	public CurrencyId: eCurrency;
	public Season: number;
	public EpisodesInSeason?: number;
	public SeasonPremiereDate?: Date | null;
	public UfPaymentsReceived?: number;
	public EstimateUfPerSeason?: number;
	public EstimateUfPerEp?: number;
	public ScheduledUfRemaining?: number;
	public NavId: string;
	public IsActive: boolean;
	public BookingNumber: string;
	public IsManuallyManaged: boolean;
}
export class Tv10ClientAssocDataDto
{
	public Client: ContactCardDto;
	public ClientName: string;
	public Position: eTv10PercentPosition;
	public PositionDescription: string;
	public BookingId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class Tv10BuyerAssocDataDto
{
	public Buyer: ContactCardDto;
	public BuyerName: string;
	public Position: eTv10PercentPosition;
	public PositionDescription: string;
	public BookingId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class Tv10AttachmentDataDto
{
	public AttachmentAssocId: string;
	public BookingId: string;
	public Type: eTv10PercentAttachmentType;
	public TypeDescription: string;
	public Id: string;
	public ActionState: eActionState;
	public FileName: string;
	public Description: string;
	public FileId: string;
	public IsDeleted: boolean;
	public User: string;
	public Date: Date;
	public SizeInBytes: number;
	public ImageSize: eImageSize;
	public Path: string;
	public EmlAttachmentNum: number;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class Tv10BookingDto
{
	public BookingNumber: string;
	public Title: string;
	public Agent: ContactCardDto;
	public AccountingContact: ContactCardDto;
	public Client: ContactCardDto;
	public ClientLoanoutId?: string;
	public Loanouts: ContactLoanoutDto[];
	public Buyer: ContactCardDto;
	public StartDate: Date;
	public DateOfBooking?: Date | null;
	public Guerantee?: number;
	public Office: eOffice;
	public IsWmePackage: boolean;
	public Category: eTv10PercentBookingCategory;
	public Status: eTv10PercentBookingStatus;
	public Type: eTv10PercentBookingType;
	public Length: eTv10PercentLength;
	public Format: eTv10PercentFormat;
	public Level: eTv10PercentLevel;
	public DealMemo: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class Tv10BookingGridDataDto
{
	public Id: string;
	public ClientId: string;
	public BuyerId: string;
	public AgentId: string;
	public FullName: HyperlinkDto;
	public Client: string;
	public Buyer: string;
	public Agent: string;
	public Guarantee?: number;
	public Status: string;
	public StatusId: eTv10PercentBookingStatus;
	public Date?: Date | null;
}
export class Tv10NoteDataDto
{
	public BookingId: string;
	public Type: eTv10PercentBookingNoteType;
	public TypeName: string;
	public User: string;
	public Date: Date;
	public Note: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class Tv10PaymentDataDto
{
	public BookingId: string;
	public Name: string;
	public EpisodeNumber: string;
	public Currency: CurrencyDto;
	public PaymentType: eTv10PercentPaymentType;
	public PaymentTypeDescription: string;
	public Commission?: number;
	public PaymentDueDate?: Date | null;
	public ServiceDate?: Date | null;
	public PostedDate?: Date | null;
	public NetAmount: number;
	public ExpectedRevAmount?: number;
	public EstimatedBasisAmount?: number;
	public AmountPaid?: number;
	public Note: string;
	public IsActive: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class SearchClientListOptions
{
	public ClientTypes: eItineraryClientListTypes;
	public Filters: FilterCollection;
	public DetailId: string;
	public Page: number;
	public PageSize: number;
	public SortingOptions: SortingOptions[];
	public SearchString: string;
}
export class SearchContactsOptions
{
	public Search: string;
	public Section: eContactSection;
	public Types: eSearchContactType[];
	public ContactSubTypes: eSearchContactSubType[];
	public UserSubTypes: eSearchUserSubType[];
	public AgentSubTypes: eSearchAgentSubType[];
	public Statuses: eClientStatus[];
	public Initials: string;
	public NickName: string;
	public FirstName: string;
	public LastName: string;
	public PhoneNumber: string;
	public CompanyName: string;
	public ContactNumber: string;
	public Gender: eGender;
	public Industries: string;
	public WorkAreas: eContactWorkArea[];
	public WorkTypes: eContactWorkType[];
	public BuyerMarketTypes: eBuyerMarket[];
	public Offices: eOffice[];
	public Departments: eDepartment[];
	public Ethnicities: eEthnicity[];
	public Nationalities: eNationality[];
	public AgeRanges: eContactAgeRange;
	public DemographicAppeal: string;
	public BasedIn: string;
	public Tags: string;
	public UserLists: string;
	public City: string;
	public State: string;
	public Country: eCountry;
	public DobFrom: string;
	public DobTo: string;
	public Assistant: string;
	public Associate: string;
	public Position: string;
	public TaxNumbers: string;
	public Loanouts: string;
	public SkipContactIds: string;
	public ActiveClientsOnly?: boolean;
	public AgentsOnly?: boolean;
	public PrivateOnly?: boolean;
	public RestrictedContactIds: string;
	public IncludeArchived?: boolean;
	public IsPending?: boolean;
	public PageSize?: number;
}
export class SearchExternalCalendarOptions
{
	public ExternalCalendarType: eExternalCalendarTypes;
	public Filters: FilterCollection;
	public DetailId: string;
	public Page: number;
	public PageSize: number;
	public SortingOptions: SortingOptions[];
	public SearchString: string;
}
export class SearchTitlesOptions
{
	public Types: number[];
	public Search: string;
}
export class ReportDto
{
	public Id: string;
	public ReportType: eReportType;
	public JsonParameters: string;
	public DurationInMilliseconds?: number;
	public CreatedOn: Date;
	public CreatedById: string;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
}
export abstract class ASearchParametersBase
{
	public DetailId: string;
	public Page: number;
	public PageSize: number;
	public SortingOptions: SortingOptions[];
	public SearchString: string;
}
export class BaseGridDataDto
{
	public ActionState: eActionState;
}
export class ClientGridDto
{
	public GridSettings: GridDto;
	public GridData: ClientGridDataDto[];
}
export class GridColumnDto
{
	public Id: string;
	public Header: string;
	public Field: string;
	public Order: number;
	public IsSortable: boolean;
	public Sorting?: number;
	public IsEditable: boolean;
	public IsHidden: boolean;
	public ColumnType: eColumnType;
	public ListDelimiter: string;
	public Width: number;
	public Format: string;
	public IsTimeZone?: boolean;
}
export class GridColumns
{
	public Field: string;
	public Header: string;
	public Order: number;
	public IsSortable: boolean;
	public ColumnType: eColumnType;
	public Width: number;
}
export class GridColumnV2Dto
{
	public Id: string;
	public Header: string;
	public Field: string;
	public Order: number;
	public IsSortable: boolean;
	public Sorting: number;
	public Sort: string;
	public IsEditable: boolean;
	public IsHidden: boolean;
	public Pinned: string;
	public ColumnType: eColumnType;
	public ListDelimiter: string;
	public Width: number;
	public Format: string;
}
export class GridDto
{
	public Id: string;
	public Option: GridOptionDto;
	public IsActive: boolean;
	public IsAreaDefault: boolean;
	public GridArea: eGridArea;
	public GridType: eGridType;
	public IsEditable: boolean;
	public SystemDefaultColumns: GridColumnDto[];
	public SelectOptions: GridOptionDto[];
	public Columns: GridColumnDto[];
	public Filters: AFilterBase[];
	public AppliedFilters: FilterCollection;
	public DefaultGridId: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class GridOptionDto
{
	public Id: string;
	public GridType: eGridType;
	public Name: string;
}
export class GridSettings
{
	public Id: string;
	public Name: string;
	public GridType: eGridType;
	public Columns: GridColumns[];
	public IsActive: boolean;
}
export class GridV2Dto
{
	public Option: GridOptionDto;
	public IsActive: boolean;
	public IsAreaDefault: boolean;
	public GridArea: eGridArea;
	public GridType: eGridType;
	public IsEditable: boolean;
	public SystemDefaultColumns: GridColumnV2Dto[];
	public SelectOptions: GridOptionDto[];
	public Columns: GridColumnV2Dto[];
	public Filters: AFilterBase[];
	public AppliedFilters: FilterCollection;
	public DefaultGridId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class SearchParameters
{
	public Filters: FilterCollection;
	public DetailId: string;
	public Page: number;
	public PageSize: number;
	public SortingOptions: SortingOptions[];
	public SearchString: string;
}
export class ServerPagingResult<TData>
{
	public Data: TData[];
	public Page: number;
	public PageSize: number;
	public TotalCount: number;
}
export class SortingOptions
{
	public Field: string;
	public Dir: eSortDir;
}
export abstract class AFilterBase
{
	public FilterType: eFilterFieldType;
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public SubFilters: AFilterBase[];
}
export class FilterCheckBox
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterCollection
{
	public List: FilterValueCollection[];
}
export class FilterContainer
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterDate
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterDateBetween
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterEmpty
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterMultiSelect
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public Source: string;
	public SourceValues: FilterValue[];
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterNgMultiSelect
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public Source: string;
	public IsGroup: boolean;
	public SourceValues: FilterValue[];
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterNgMultiSelectSearch
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public Types: eSearchContactType[];
	public SourceValues: FilterValue[];
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterPickerContact
{
	public FilterName: string;
	public Types: eSearchContactType[];
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterPickerEnum
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public Source: string;
	public SourceValues: FilterValue[];
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterSearch
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterSingleSelect
{
	public FilterName: string;
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public Source: string;
	public SourceValues: FilterValue[];
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterSingleSelectSearch
{
	public FilterName: string;
	public Types: number[];
	public ColumnName: string;
	public Title: string;
	public SortOrder: number;
	public FilterType: eFilterFieldType;
	public SubFilters: AFilterBase[];
}
export class FilterValue
{
	public Key: string;
	public Value: string;
	public EntityType: string;
}
export class FilterValueCollection
{
	public ColumnName: string;
	public List: FilterValue[];
}
export class ClientCommissionGridDataDto
{
	public Id: string;
	public Department: string;
	public Region: string;
	public Commission: number;
	public UsAps: string;
	public UsAllow: boolean;
	public UkAllow: boolean;
	public SkipAps: boolean;
	public Notes: string;
	public Modified: string;
}
export class ClientGridDataDto
{
	public Id: string;
	public IsActive: boolean;
	public FullName: HyperlinkDto;
	public SubType: string;
	public ClientStatus: string;
	public Company: HyperlinkDto;
	public Representation: string;
	public PrimaryAddress: AddressDto;
	public Phone: string;
	public Email: string;
	public WorkAreas: string[];
	public WorkTypes: string[];
}
export class EmailMessageDto
{
	public Id: string;
	public SenderName: string;
	public SenderEmail: string;
	public RecipientName: string;
	public RecipientEmail: string;
	public Subject: string;
	public Body: string;
	public EmailTemplateTypeId?: number;
	public SentOn?: Date | null;
	public Status: string;
	public LastChangedOn: Date;
	public LastChangedBy: string;
}
export class EmailStatusDto
{
	public EmailId: string;
	public SendGridEventId: string;
	public EmailStatusTypeId?: number;
	public Event: string;
	public EmailAddress: string;
	public Status: string;
	public JsonData: string;
	public LastChangedOn: Date;
	public LastChangedBy: number;
}
export class EmailStatusTypeDto
{
	public Id: number;
	public Name: string;
}
export class UserDatabrokerDto
{
	public AzureObjectId?: string;
	public BusinessUnitId: number;
	public EmployeeTypeId: number;
	public OfficeId?: number;
	public Position: string;
	public Initials: string;
	public GenderId?: number;
	public StartDate?: Date | null;
	public IsFormer: boolean;
	public AzureUPN: string;
	public TitleId: number;
	public CompanyName: string;
	public OtherCompanyName: string;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public FullName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public ContactNumber: string;
	public IsActive: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class DealDataBrokerDto
{
	public Id: string;
	public Title: string;
	public Agent: string;
	public Status: eDealStatus;
	public Type: eDealType;
	public IsPrivate: boolean;
	public FestivalRider: boolean;
	public StartDate: Date;
	public EndDate?: Date | null;
	public CrossCollateralization: eDealCrossCollateralizedLevel;
	public AnnualEvent: boolean;
	public DealNumber: string;
	public Client: string;
	public Buyer: string;
	public Currency: eCurrency;
	public CrossCollateralizationText: string;
	public OfferExpires?: Date | null;
	public Guerantee?: number;
	public Walkout?: number;
	public Commision: number;
	public CommisionComment: string;
	public ClientLoanoutId?: string;
	public IsNavisionBooking: boolean;
	public AnualEvent: boolean;
	public BuyingOnBehalfOf: string;
	public FestivalName: string;
	public FestivalId?: string;
}
export class AddressDataBrokerDto
{
	public Country: eCountry;
	public AddressLine1: string;
	public AddressLine2: string;
	public City: string;
	public State: string;
	public PostalCode: string;
	public Comment: string;
	public IsPreferred?: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class AgentDataBrokerDto
{
	public Id: string;
	public EmployeeId: string;
	public FullName: string;
	public IsSigningAgent: boolean;
	public IsPointAgent: boolean;
}
export class AmountDataBrokerDto
{
}
export class AssociateDataBrokerDto
{
	public ContactId: string;
	public RecordId: string;
	public Comment: string;
	public Name: string;
	public ContactTypeId: eContactType;
	public Company: string;
	public Contact: ContactDto;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class AttachmentDataBrokerDto
{
	public FileName: string;
	public Description: string;
	public FileId: string;
	public IsDeleted: boolean;
	public User: string;
	public Date: Date;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class BaseDataBrokerDto
{
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class BaseListItemDataBrokerDto
{
	public Key: number;
	public Value: string;
	public IsSelected: boolean;
}
export class ContactBaseDataBrokerDto
{
	public CompanyName: string;
	public OtherCompanyName: string;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public FullName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public ContactNumber: string;
	public IsActive: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ContactLoanoutDataBrokerDto
{
	public ContactLoanoutId: string;
	public ContactId: string;
	public RecordId: string;
	public LoanoutName: string;
	public TaxNumber: string;
	public Suffix: string;
	public Note: string;
	public IsUk: boolean;
	public IsAus: boolean;
	public IsGSTReg: boolean;
	public IsActive: boolean;
	public IsForeign: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ContactSelectorDataBrokerDto
{
	public Id: string;
	public FullName: string;
}
export class EmailAddressDataBrokerDto
{
	public Email: string;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class LoanoutDataBrokerDto
{
	public LoanoutName: string;
	public Suffix: string;
	public TaxNumber: string;
	public IsActive: boolean;
	public Note: string;
	public IsUk: boolean;
	public IsAus: boolean;
	public IsGSTReg: boolean;
	public IsForeign: boolean;
	public Comments: string;
	public SortName: string;
	public AustralianBusinessNumber: string;
}
export class PhoneDataBrokerDto
{
	public PhoneNumber: string;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientAddressDataBrokerDto
{
	public Country: eCountry;
	public AddressLine1: string;
	public AddressLine2: string;
	public City: string;
	public State: string;
	public PostalCode: string;
	public Comment: string;
	public IsPreferred?: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientAgentContactDataBrokerDto
{
	public Initials: string;
	public Department: eDepartment;
	public Username: string;
	public SecurityGroup: string;
	public PhoneNumber: string;
	public Email: string;
	public CompanyName: string;
	public OtherCompanyName: string;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public FullName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public ContactNumber: string;
	public IsActive: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientAgentDataBrokerDto
{
	public Initials: string;
	public Department: eDepartment;
	public Username: string;
	public SecurityGroup: string;
	public PhoneNumber: string;
	public Email: string;
	public CompanyName: string;
	public OtherCompanyName: string;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public FullName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public ContactNumber: string;
	public IsActive: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientDataBrokerDto
{
	public TypeId: eClientType;
	public BusinessUnit: eBusinessUnit;
	public Region: eRegion;
	public Status: eClientStatus;
	public Gender: eGender;
	public Title: eContactTitle;
	public LegacyContactId: number;
	public Position: string;
	public TeamAgents: ClientAgentDataBrokerDto[];
	public WorkTypes: eContactWorkType[];
	public Phones: ClientPhoneDataBrokerDto[];
	public Emails: ClientEmailDataBrokerDto[];
	public Addresses: ClientAddressDataBrokerDto[];
	public Loanouts: ClientLoanoutDataBrokerDto[];
	public CompanyName: string;
	public OtherCompanyName: string;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public FullName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public ContactNumber: string;
	public IsActive: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientLoanoutAssocDataBrokerDto
{
	public RecordId: string;
	public ContacLoanoutId: string;
	public ContactLoanout: ContactLoanoutDto;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientLoanoutDataBrokerDto
{
	public LoanoutName: string;
	public Suffix: string;
	public TaxNumber: string;
	public IsActive: boolean;
	public Note: string;
	public IsUk: boolean;
	public IsAus: boolean;
	public IsGSTReg: boolean;
	public IsForeign: boolean;
	public Comments: string;
	public SortName: string;
	public AustralianBusinessNumber: string;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientPhoneDataBrokerDto
{
	public ClientPhoneTypeId: eClientPhoneType;
	public PhoneNumber: string;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ClientEmailDataBrokerDto
{
	public Type: eClientEmailType;
	public Email: string;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class BuyerAccountingPeriodDateDataBrokerDto
{
	public BuyerId: string;
	public DayOfPeriod: number;
	public MonthOfPeriod: number;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class BuyerAddressDataBrokerDto
{
	public Country: eCountry;
	public AddressLine1: string;
	public AddressLine2: string;
	public City: string;
	public State: string;
	public PostalCode: string;
	public Comment: string;
	public IsPreferred?: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class BuyerDataBrokerDto
{
	public OtherCompanyName: string;
	public WebSite: string;
	public OutletTypeId?: number;
	public Emails: BuyerEmailDataBrokerDto[];
	public Addresses: BuyerAddressDataBrokerDto[];
	public Phones: BuyerPhoneDataBrokerDto[];
	public BuyerMarkets: eBuyerMarket[];
	public CompanyName: string;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public FullName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public ContactNumber: string;
	public IsActive: boolean;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class BuyerEmailDataBrokerDto
{
	public BuyerId: string;
	public Email: string;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public Type: eBuyerEmailType;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class BuyerPhoneDataBrokerDto
{
	public BuyerPhoneType: eBuyerPhoneType;
	public PhoneNumber: string;
	public DataBrokerGuid: string;
	public SourceSystemId: number;
	public Id: string;
	public ActionState: eActionState;
}
export class ContactAddressDto
{
	public ContactId: string;
	public Address: AddressDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactAdvancedSearchGridDto
{
	public Id: string;
	public Type: eContactType;
	public Name: string;
	public Company: string;
	public City: string;
	public State: string;
	public CountryId: eCountry;
	public Country: string;
	public Phone: string;
	public Email: string;
	public ContactId: string;
}
export class ContactAgentDto
{
	public ContactId: string;
	public UserId: string;
	public FullName: string;
	public PhoneNumber: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactAgentIncomeAnalysisAgentDto
{
	public ContactId: string;
	public UserId: string;
	public ContactAgentIncomeAnalysisPeriodId: string;
	public FullName: string;
	public PhoneNumber: string;
	public Department?: eDepartment;
	public Split: number;
	public IsPointAgent: boolean;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactAgentIncomeAnalysisPeriodDto
{
	public ContactId: string;
	public StartDate: Date;
	public EndDate?: Date | null;
	public IsDeleted: boolean;
	public ContactAgentIncomeAnalysisAgents: ContactAgentIncomeAnalysisAgentDto[];
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactAgeRangeAssocDto
{
	public AgeRange: eContactAgeRange;
	public ContactId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactAssociationDto
{
	public ContactId: string;
	public AssociateContactId: string;
	public Comment: string;
	public Name: string;
	public ContactTypeId: eContactType;
	public Company: string;
	public AssistantContact: ContactDto;
	public Contact: ContactDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactCitizenshipDto
{
	public ContactId: string;
	public Citizenship: eCitizenship;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactDto
{
	public ContactType: eContactCategory;
	public AssistantContactId?: string;
	public FullName: string;
	public LastModifiedBy: string;
	public IsActive: boolean;
	public IsBioSyncReady: boolean;
	public SocialSecurityNumber: string;
	public AustralianBusinessNumber: string;
	public IsW9OnFile: boolean;
	public BasedInCountryId: eCountry;
	public AcceptChecks: boolean;
	public IsApproved: boolean;
	public IsAlien: boolean;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public CompanyName: string;
	public Position: string;
	public Comment: string;
	public Assistant: ContactCardDto;
	public WorkAreas: ContactWorkAreaAssocDto[];
	public WorkTypes: ContactWorkTypeAssocDto[];
	public AgeRange: ContactAgeRangeAssocDto[];
	public Phones: ContactPhoneDto[];
	public Emails: ContactEmailDto[];
	public Addresses: ContactAddressDto[];
	public Agents: ContactAgentIncomeAnalysisPeriodDto[];
	public Notes: ContactNoteDto[];
	public Citizenship: ContactCitizenshipDto[];
	public Ethnicity: ContactEthnicityDto[];
	public Nationality: ContactNationalityDto[];
	public Title: eContactTitle;
	public ContactSubType: eContactType;
	public StatusFilter: eContactStatusFilter;
	public Status: eContactStatus;
	public Gender: eGender;
	public BusinessUnit: eBusinessUnit;
	public LastModifiedOn?: Date | null;
	public BirthDate: Date;
	public MigrationId?: number;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactEmailDto
{
	public Type: eContactEmailType;
	public NameType: string;
	public ContactId: string;
	public IsPrivate: boolean;
	public IsPreferred: boolean;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public TempId: number;
	public RowEdit: boolean;
	public Id: string;
	public ActionState: eActionState;
	public Email: string;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactEthnicityDto
{
	public ContactId: string;
	public Ethnicity: eEthnicity;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactGridDto
{
	public Id: string;
	public IsActive: boolean;
	public FullName: HyperlinkDto;
	public ClientStatus: string;
	public PrimaryAddress: ContactAddressDto;
	public Address: AddressDto;
	public Phone: string;
	public Email: string;
	public ContactTypeId: string;
	public Name: string;
}
export class ContactLoanoutAssocDto
{
	public ContactId: string;
	public ContacLoanouttId: string;
	public ContactLoanout: ContactLoanoutDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactNationalityDto
{
	public ContactId: string;
	public Nationality: eNationality;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactPhoneDto
{
	public ContactId: string;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public ContactPhoneTypeId: eContactPhoneType;
	public PhoneType: string;
	public PhoneNumber: string;
	public IsPrivate: boolean;
	public IsPreferred: boolean;
	public TempId: number;
	public RowEdit: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactRepDto
{
	public ContactId: string;
	public Representation: eBusinessUnit;
	public RepresentationStartDate: Date;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactWorkAreaAssocDto
{
	public WorkArea: eContactWorkArea;
	public ContactId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactWorkTypeAssocDto
{
	public WorkType: eContactWorkType;
	public ContactId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class MergeContactsDto
{
	public WinnerRecordId: number;
	public LoserRecordId: number;
}
export class ContactNoteDto
{
	public ContactId: string;
	public CreatedBy: string;
	public Note: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactAttachmentDto
{
	public ContactId: string;
	public Name: string;
	public Type: eContactAttachmentType;
	public IssueDate?: Date | null;
	public ExpirationDate?: Date | null;
	public Id: string;
	public ActionState: eActionState;
	public FileName: string;
	public Description: string;
	public FileId: string;
	public IsDeleted: boolean;
	public User: string;
	public Date: Date;
	public SizeInBytes: number;
	public ImageSize: eImageSize;
	public Path: string;
	public EmlAttachmentNum: number;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class AdminUserDto
{
	public UserName: string;
	public FirstName: string;
	public MiddleName: string;
	public LastName: string;
	public Initials: string;
	public FullName: string;
	public EmployeeNumber?: number;
	public Position: string;
	public PrimaryPhone: string;
	public SecondaryPhone: string;
	public PrimaryEmail: string;
	public SecondaryEmail: string;
	public StartDate?: Date | null;
	public SettingsJson: string;
	public SlugRoot: string;
	public SlugSuffix?: number;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public EmployeeTypeId: eUserType;
	public BusinessUnitId: eBusinessUnit;
	public GenderId: eGender;
	public TitleId: eContactTitle;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientAddressDto
{
	public ClientId: string;
	public Address: AddressDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientAgentContactDto
{
	public ClientId: string;
	public FullName: string;
	public PhoneNumber: string;
	public Department: eDepartment;
}
export class ClientAgentDto
{
	public ClientId: string;
	public UserId: string;
	public FullName: string;
	public PhoneNumber: string;
	public Department?: eDepartment;
	public IsSigningAgent: boolean;
	public IsPointAgent: boolean;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientAgeRangeAssocDto
{
	public AgeRange: eContactAgeRange;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientAssociateDto
{
	public ContactId: string;
	public ClientId: string;
	public Comment: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientAssociationDto
{
	public ContactId: string;
	public ClientId: string;
	public Comment: string;
	public ContactTypeId: eContactType;
	public Company: string;
	public Client: ClientDto;
	public Contact: ContactDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientCitizenshipAssocDto
{
	public Citizenship: eCitizenship;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientCompanyAssocDto
{
	public ClientId: string;
	public ContactCompanyId: string;
	public CompanyName: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientDto
{
	public LastModifiedBy: string;
	public IsActive: boolean;
	public IsBioSyncReady: boolean;
	public FirstName: string;
	public LastName: string;
	public MiddleName: string;
	public NickName: string;
	public FullName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public CompanyName: string;
	public Position: string;
	public Comment: string;
	public Assistant: ContactCardDto;
	public Region: eRegion;
	public BasedIn?: number;
	public ThumbnailUrl: string;
	public SubType: string;
	public NA: string;
	public Age: number;
	public GrossAmount: number;
	public NetAmmount: number;
	public DatabrokerGuid?: string;
	public Number: string;
	public WorkAreas: ClientWorkAreaAssocDto[];
	public WorkTypes: ClientWorkTypeAssocDto[];
	public Citizenships: ClientCitizenshipAssocDto[];
	public Ethnicities: ClientEthnicityAssocDto[];
	public Nationalities: ClientNationalityAssocDto[];
	public TerritoriesOfRepresentation: ClientRepresentationTerritoryDto[];
	public LiteraryGenres: ClientLiteraryGenreDto[];
	public FilmAndTelevisionGenres: ClientFilmAndTelevisionGenreDto[];
	public MusicGenres: ClientMusicGenreDto[];
	public AgeRange: ClientAgeRangeAssocDto[];
	public Phones: ClientPhoneDto[];
	public Emails: ClientEmailDto[];
	public Addresses: ClientAddressDto[];
	public Agents: ClientAgentDto[];
	public Notes: ClientNoteDto[];
	public RepresentationForm: RepresentationFormDto;
	public Title: eContactTitle;
	public TypeId: eClientType;
	public Status: eClientStatus;
	public Gender: eGender;
	public BusinessUnit: eBusinessUnit;
	public LastModifiedOn?: Date | null;
	public BirthDate: Date;
	public MigrationId: number;
	public DeathDate?: Date | null;
	public Social: SocialDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientEditDto
{
	public ClientId: string;
	public Id: string;
	public Company: string;
	public ClientTypeId: eClientType;
	public Status: eClientStatus;
	public RepresentationCompany: eBusinessUnit;
	public WorkAreas: eContactWorkArea[];
	public WorkTypes: eContactWorkType[];
	public Citizenships: eCitizenship[];
	public Ethnicities: eEthnicity[];
	public Nationalities: eNationality[];
	public TerritoriesOfRepresentation: eRegion[];
	public LiteraryGenres: eClientGenreLiterary[];
	public FilmAndTelevisionGenres: eClientGenreFilmAndTv[];
	public MusicGenres: eClientGenreMusic[];
	public Title: eContactTitle;
	public Gender: eGender;
	public AgeRange: eContactAgeRange;
	public FirstName: string;
	public MiddleName: string;
	public LastName: string;
	public FullName: string;
	public NickName: string;
	public LegalFirstName: string;
	public LegalMiddleName: string;
	public LegalLastName: string;
	public Position: string;
	public Social: SocialDto;
	public Region: eRegion;
	public BusinessUnit: eBusinessUnit;
	public Phones: ClientPhoneDto[];
	public Emails: ClientEmailDto[];
	public Addresses: AddressDto[];
	public Avatar: string;
	public IsArchived: boolean;
	public IsActive: boolean;
	public IsConfidental: boolean;
}
export class ClientEmailViewDto
{
	public Id: string;
	public Type: string;
	public Address: string;
}
export class ClientEthnicityAssocDto
{
	public Ethnicity: eEthnicity;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientFilmAndTelevisionGenreDto
{
	public FilmAndTelevisionGenre: eClientGenreFilmAndTv;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientLiteraryGenreDto
{
	public LiteraryGenre: eClientGenreLiterary;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientLoanoutAssocDto
{
	public RecordId: string;
	public ContacLoanoutId: string;
	public ContactLoanout: ContactLoanoutDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientMusicGenreDto
{
	public MusicGenre: eClientGenreMusic;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientNationalityAssocDto
{
	public Nationality: eNationality;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientPhoneDto
{
	public ClientId: string;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public ClientPhoneTypeId: eClientPhoneType;
	public PhoneNumber: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientPhoneViewDto
{
	public Id: string;
	public Type: string;
	public Number: string;
}
export class ClientRepresentationTerritoryDto
{
	public RepresentationTerritory: eRegion;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientWorkAreaAssocDto
{
	public WorkArea: eContactWorkArea;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientWorkTypeAssocDto
{
	public WorkType: eContactWorkType;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class CompanyDto
{
	public Id: string;
	public LastModifiedBy: string;
	public LastModifiedOn: Date;
	public Name: string;
	public Comment: string;
}
export class GenresDto
{
	public Drama: string[];
	public FilmAndTelivision: string[];
	public Music: string[];
	public Literary: string[];
	public Terretories: string[];
}
export class SocialDto
{
	public Website: string;
	public Facebook: string;
	public Twitter: string;
	public Instagram: string;
	public Youtube: string;
	public Other: string;
}
export class VwClientGridDto
{
	public Id: string;
	public IsActive: boolean;
	public FullName: string;
	public ClientTypeId: number;
	public Type: string;
	public Status: string;
	public Company: string;
	public Address: string;
	public City: string;
	public PostalCode: string;
	public PhoneNumber: string;
	public Email: string;
	public Representation: string;
	public WorkArea: string;
	public WorkType: string;
}
export class ClientAdditionalFormDto
{
	public Id: string;
	public ClientId: string;
	public PriceQuote: number;
	public Current: boolean;
	public Afm: boolean;
	public InternationalOnly: boolean;
	public SearchContact: AgentDto[];
	public PointAgent: AgentDto;
	public NotifyLevel: eClientNotifyLevel;
	public AgentNote: string;
	public PaPress: string;
	public DealPoint: string;
}
export class ClientEmailDto
{
	public Type: eClientEmailType;
	public NameType: string;
	public ClientId: string;
	public Id: string;
	public ActionState: eActionState;
	public Email: string;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class InformationViewDto
{
	public Id: string;
	public FullName: string;
	public Phones: ClientPhoneViewDto[];
	public Type: string;
	public Status: string;
	public Emails: ClientEmailDto[];
	public Agents: ClientAgentContactDto[];
	public Addresses: ClientAddressDto[];
	public ImageUrl: string;
	public TotalGross: string;
	public TotalGrossYear: string;
	public TotalNet: string;
	public TotalNetYear: string;
	public WorkAreas: string[];
	public WorkTypes: string[];
	public AgeRange: string;
	public LiteraryGenres: string[];
	public FilmAndTelevisionGenres: string[];
	public MusicGenres: string[];
	public Notes: NoteViewDto[];
}
export class NoteViewDto
{
	public CreatedBy: string;
	public CreatedAt: Date;
	public Text: string;
}
export class RepresentationFormDto
{
	public ClientId: string;
	public Representation: eBusinessUnit;
	public Status: eClientStatus;
	public SigningOffice: eOffice;
	public RepresentationStartDate: Date;
	public SigningAgents: ClientAgentDto[];
	public Comments: string;
	public Sent: boolean;
	public Signed: boolean;
	public Expired: boolean;
	public Created: boolean;
	public Renewal: boolean;
	public FirstSigning: boolean;
	public FormerClientAsOf?: Date | null;
	public Per: string;
	public PreviousAgency: string;
	public ClientWentTo: string;
	public CurrentAgency: string;
	public LetterSentTo: string;
	public TerminationLetter: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class AgentIncomeAnalysisAgentDto
{
	public PeriodId: string;
	public IsAgentIncomeAnalysisAgentPoint: boolean;
	public Split: number;
	public Id: string;
	public EmployeeId: string;
	public FullName: string;
	public IsSigningAgent: boolean;
	public IsPointAgent: boolean;
}
export class AgentIncomeAnalysisPeriodGridDataDto
{
	public Id: string;
	public ClientId: string;
	public StartDate: Date;
	public EndTime?: Date | null;
	public SigningAgentCodes: string[];
	public Agents: AgentIncomeAnalysisAgentDto[];
	public ClientCreatedOn?: Date | null;
	public LastModifiedBy: string;
	public LastModifiedOn: Date;
}
export class AssociateGridData
{
	public Id: string;
	public Type: string;
	public Company: string;
	public Comment: string;
}
export class ClientAccountingGeneralDto
{
	public ClientId: string;
	public Ss: string;
	public Abn: string;
	public NonResidentAlien: boolean;
	public W9OnFile: boolean;
	public WmeAuthorized: boolean;
	public Notes: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientCommissionDto
{
	public ClientId: string;
	public Department: eClientDepartment;
	public Region: eRegion;
	public Commision: number;
	public UsAps: string;
	public UsAllow?: boolean;
	public UkAllow?: boolean;
	public SkipAps: boolean;
	public Notes: string;
	public IsDeleted: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientParticipantFormDto
{
	public FullName: string;
	public ClientId: string;
	public ContactId: string;
	public Split?: number;
	public HoldPayment: boolean;
	public Address: ContactAddressDto;
	public PaymentMethod?: eClientPaymentMethod;
	public ParticipantType?: eClientParticipantType;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class LoanoutGridDataDto
{
	public Id: string;
	public ClientId: string;
	public FullName: HyperlinkDto;
	public ActiveFlag: boolean;
	public TaxpayerId: string;
	public FcFlag: boolean;
	public UkFlag: boolean;
	public AusFlag: boolean;
	public GstFlag: boolean;
}
export class ParticipantGridDataDto
{
	public FullName: HyperlinkDto;
	public Id: string;
	public ClientId: string;
	public Split: number;
	public HoldFlag: boolean;
	public Address: AddressDto;
	public PaymentMethod: string;
	public ParticipantType: string;
}
export class ClientNoteDto
{
	public ClientId: string;
	public CreatedBy: string;
	public Note: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ClientAttachmentDto
{
	public ClientId: string;
	public Name: string;
	public AttachmentId: string;
	public ClientAttachmentTypeId: eClientAttachmentType;
	public IssueDate?: Date | null;
	public ExpirationDate?: Date | null;
	public Attachment: AttachmentDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerAccountingInformationDto
{
	public BuyerId: string;
	public Ss: string;
	public Abn: string;
	public NonResidentAlien: boolean;
	public W9OnFile: boolean;
	public WmeAuthorized: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerAccountingPeriodDateDto
{
	public BuyerId: string;
	public DayOfPeriod: number;
	public MonthOfPeriod: number;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerAddressDto
{
	public BuyerId: string;
	public Address: AddressDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerAdvancedSearchGridDto
{
	public Id: string;
	public MigrationId: string;
	public Company: string;
	public City: string;
	public State: string;
	public Country: string;
	public PhoneNo: string;
	public BuyerNo: string;
	public Associates: BuyerAssociateGridDto[];
}
export class BuyerAdvancedSearchParamatersDto
{
	public CompanyName: string;
	public BuyerAssociate: string;
	public BuyerType: eBuyerCompanyType;
	public City: string;
	public State: string;
	public Country: string;
}
export class BuyerAgentDto
{
	public BuyerId: string;
	public UserId: string;
	public FullName: string;
	public PhoneNumber: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerAssociateDto
{
	public ContactId: string;
	public BuyerId: string;
	public Comment: string;
	public Name: string;
	public ContactTypeId: eContactType;
	public Company: string;
	public Buyer: BuyerDto;
	public Contact: ContactDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerAssociateGridDto
{
	public ActionState: eActionState;
	public Id?: string;
	public AssociateId: string;
	public Name: HyperlinkDto;
	public BuyerName: string;
	public Email: string;
	public AssociateType: eDealBuyerAssociate;
	public AssociateTypeDescription: string;
}
export class BuyerCompanyTypeDto
{
	public BuyerCompanyType: eBuyerCompanyType;
	public BuyerId: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerDto
{
	public CompanyName: string;
	public OtherName: string;
	public FormerName: string;
	public Number: string;
	public ParentCompany: string;
	public ParentCompanyId?: string;
	public Product: string;
	public Comment: string;
	public SocialSecurityNumber: string;
	public AustralianBusinessNumber: string;
	public IsW9OnFile: boolean;
	public AcceptChecks: boolean;
	public IsAlien: boolean;
	public IsExpenseContact: boolean;
	public IsActive: boolean;
	public DaysOfClose?: number;
	public Website: string;
	public MigrationId?: number;
	public BuyerCategory: eBuyerCategory;
	public OutletType?: eTvPckgOutletType;
	public BuyerNotificationMethod: eBuyerNotificationMethod;
	public CompanyType: BuyerCompanyTypeDto[];
	public Addresses: BuyerAddressDto[];
	public Loanouts: ContactLoanoutDto[];
	public BuyerTeam: string[];
	public PhoneNumbers: BuyerPhoneDto[];
	public Emails: BuyerEmailDto[];
	public BuyerMarkets: BuyerMarketAssocDto[];
	public BuyerAccountingPeriodDates: BuyerAccountingPeriodDateDto[];
	public DatabrokerGuid?: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerEmailDto
{
	public BuyerId: string;
	public Email: string;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public IsPreferred: boolean;
	public IsPrivate: boolean;
	public Type: eBuyerEmailType;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerGridDto
{
	public CompanyName: HyperlinkDto;
	public CompanyType: string;
	public PrimaryAddress: AddressDto;
	public PhoneNumber: string;
	public Email: string;
	public BuyerMarkets: string[];
	public BuyerMarketEnums: eBuyerMarket[];
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerLoanoutAssocDto
{
	public RecordId: string;
	public ContacLoanoutId: string;
	public ContactLoanout: ContactLoanoutDto;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class LoanoutDtoBuyerLoanoutDto
{
	public ContactCardDto: ContactCardDto;
	public BuyerId: string;
	public LoanoutName: string;
	public TaxNumber: string;
	public Suffix: string;
	public Note: string;
	public IsUk: boolean;
	public IsAus: boolean;
	public IsGSTReg: boolean;
	public IsActive: boolean;
	public IsForeign: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerMarketAssocDto
{
	public BuyerId: string;
	public BuyerMarketId: eBuyerMarket;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerNoteDto
{
	public BuyerId: string;
	public CreatedBy: string;
	public Note: string;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerPhoneDto
{
	public BuyerId: string;
	public PhoneNumber: string;
	public IsActive: boolean;
	public IsDeleted: boolean;
	public IsPrivate: boolean;
	public IsPreferred: boolean;
	public Type: eBuyerPhoneType;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class BuyerAttachmentDto
{
	public BuyerId: string;
	public Name: string;
	public Type: eBuyerAttachmentType;
	public IssueDate?: Date | null;
	public ExpirationDate?: Date | null;
	public Id: string;
	public ActionState: eActionState;
	public FileName: string;
	public Description: string;
	public FileId: string;
	public IsDeleted: boolean;
	public User: string;
	public Date: Date;
	public SizeInBytes: number;
	public ImageSize: eImageSize;
	public Path: string;
	public EmlAttachmentNum: number;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ContactCardDto
{
	public Id: string;
	public Avatar: string;
	public FirstName: string;
	public MiddleName: string;
	public LastName: string;
	public FullName: string;
	public UserName: string;
	public Phone: string;
	public Email: string;
	public Initials: string;
	public Number: string;
	public Address: AddressDto;
	public Agents: string[];
	public Departments: string;
	public Company: string;
	public ContactType: eContactCardType;
	public EntityType: eDatabaseContactType;
	public Profile: number;
	public DatabrokerGuid?: string;
	public IsConnect: boolean;
	public ConnectId?: number;
	public ContactConnectUrlAddress: string;
}
export class ContactCardGroupDto
{
	public ContactTypeId: number;
	public ContactType: string;
	public ContactTypeCount: number;
	public ContactCardDtos: ContactCardDto[];
}
export class VenueContactCardDto
{
	public Location: eContactVenueLocation;
	public FormerName: string;
	public Id: string;
	public Avatar: string;
	public FirstName: string;
	public MiddleName: string;
	public LastName: string;
	public FullName: string;
	public UserName: string;
	public Phone: string;
	public Email: string;
	public Initials: string;
	public Number: string;
	public Address: AddressDto;
	public Agents: string[];
	public Departments: string;
	public Company: string;
	public ContactType: eContactCardType;
	public EntityType: eDatabaseContactType;
	public Profile: number;
	public DatabrokerGuid?: string;
	public IsConnect: boolean;
	public ConnectId?: number;
	public ContactConnectUrlAddress: string;
}
export class BuyerChangeLogDto
{
	public BuyerId: string;
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class ChangeLogDto
{
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class ClientChangeLogDto
{
	public ClientId: string;
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class ContactChangeLogDto
{
	public ContactId: string;
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class DealChangeLogDto
{
	public DealId?: string;
	public BookingId?: string;
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class FieldChangeLogDto
{
	public FieldType: string;
	public FieldName: string;
	public OldValue: string;
	public NewValue: string;
	public IsReference: boolean;
}
export class ItineraryChangeLogDto
{
	public ItineraryId: string;
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class Tv10PercentChangeLogDto
{
	public BookingId: string;
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class TVPckgChangeLogDto
{
	public TvPckgPackageId: string;
	public TvPckgBookingId?: string;
	public Id: string;
	public UserId: string;
	public EntityId: string;
	public UserName: string;
	public ChangedDate: Date;
	public EntityName: string;
	public FieldNames: string[];
	public OldValues: string[];
	public NewValues: string[];
	public EventTypeDescription: string;
	public EventType: eActionState;
}
export class AgentInitialsDto
{
	public Name: string;
	public Initials: string;
	public IsPointAgent: boolean;
	public Id: string;
	public ActionState: eActionState;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public CreatedOn?: Date | null;
	public CreatedById?: string;
}
export class ResponseModel<T>
{
	public Error: string[];
	public Data: T;
	public HasData: boolean;
	public IsSuccess: boolean;
	public HasError: boolean;
}
export class SampleResponseModel
{
	public Error: string[];
	public Data: string;
	public HasData: boolean;
	public IsSuccess: boolean;
	public HasError: boolean;
}
export class DealExpenseLookupValue
{
	public Id: string;
	public Value: string;
	public IsReimbursable: boolean;
	public IsDeleted: boolean;
	public CreatedOn: Date;
	public CreatedById: string;
	public ModifiedOn?: Date | null;
	public ModifiedById?: string;
	public MigrationId?: number;
	public StringName: string;
	public SortOrder: number;
	public ShortName: string;
	public Group: string;
	public IsActive: boolean;
}
